<template>
    <div>
        <v-card flat>
            <v-card-title>
                Rotation Days
                
                <v-spacer></v-spacer>

                <v-btn depressed color="green" class="white--text" @click="openDialog(null)">Add Rotation Days</v-btn>
            </v-card-title>
            <v-card-subtitle>Add or edit customers rotation days</v-card-subtitle>

            <v-card-text class="mt-4">
                <v-row>
                    <v-col cols="12" md="4" offset-md="8">
                        <v-text-field v-model="filter" placeholder="Filter" append-icon="mdi-magnify"></v-text-field>
                    </v-col>
                </v-row>
                <v-data-table :headers="headers" :items="rotationDays" :search="filter" :loading="loading" :items-per-page="15">
                    <template v-slot:item.actions="{ item }">
                        <v-btn small depressed color="blue-grey darken-3" class="mr-2 white--text" @click="openDialog(item)">
                            <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn small depressed color="error" @click="openDeleteDialog(item)">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog v-model="newDialog" width="700" persistent>
            <v-card>
                <v-card-title>Add Rotation Days</v-card-title>
                <v-card-subtitle>Define new rotation days for an existing customer</v-card-subtitle>
                <v-card-text>
                    <v-autocomplete v-model="selected.customerId" :items="customers" item-text="fullName" item-value="id" label="Customer" :error-messages="selected.customerError"></v-autocomplete>
                    <v-row>
                        <v-col cols="6">
                            <v-menu ref="fromDate" v-model="fromDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="fromDateFormatted" label="From Date" hint="MM/DD/YYYY format" persistent-hint 
                                        prepend-icon="mdi-calendar" v-bind="attrs" @blur="fromDate = parseDate(fromDateFormatted)" v-on="on" :error-messages="selected.fromDateError">
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="selected.fromDate" no-title @input="fromDateMenu = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="6">
                            <v-menu ref="toDate" v-model="toDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="toDateFormatted" label="To Date" hint="MM/DD/YYYY format" persistent-hint 
                                        prepend-icon="mdi-calendar" v-bind="attrs" @blur="toDate = parseDate(toDateFormatted)" v-on="on" :error-messages="selected.toDateError">
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="selected.toDate" no-title @input="toDateMenu = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed text @click="closeDialog">Cancel</v-btn>
                    <v-btn depressed color="primary" @click="saveRotation">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="warningDialog" width="500" persistent>
            <v-card>
                <v-card-title>Warning</v-card-title>
                <v-card-text>Are you sure you want to delete this rotaion days? This can't be undone.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeDeleteDialog">Cancel</v-btn>
                    <v-btn text color="error" @click="deleteRotation">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            headers: [
                { text: 'Customer', value: 'fullName', align: 'left', sortable: true },
                { text: 'From Date', value: 'fromDate', align: 'left', sortable: true },
                { text: 'To Date', value: 'toDate', align: 'left', sortable: true },
                { text: 'Actions', value: 'actions', align: 'start', sortable: false, width: '15%' },
            ],
            rotationDays: [],
            customers: [],

            filter: '',

            loading: false,

            selected: {
                rotationNum: null,
                customerId: null,
                customerError: '',
                fromDate: null,
                fromDateError: '',
                toDate: null,
                toDateError: '',
            },
            newDialog: false,
            warningDialog: false,

            fromDate: new Date().toISOString().substr( 0, 10 ),
            fromDateFormatted: this.formatDate( new Date().toISOString().substr( 0, 10 ) ),
            fromDateMenu: false,
            toDate: new Date().toISOString().substr( 0, 10 ),
            toDateFormatted: this.formatDate( new Date().toISOString().substr( 0, 10 ) ),
            toDateMenu: false,
        }
    },
    watch: {
        selected: {
            deep: true,
            handler( v ) {
                this.fromDateFormatted = this.formatDate( v.fromDate );
                this.toDateFormatted = this.formatDate( v.toDate );
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.loading = true;
            this.$http
                .get( '/proc/data.php', {
                    params: {
                        action: 'getRotationDays'
                    }
                })
                .then( response => { 
                    if( response.data.message == 'Unauthorized' ) 
                        this.$router.push('/login');

                    this.loading = false;
                    this.rotationDays = response.data;
                });
            
            this.$http
                .get( '/proc/data.php', {
                    params: {
                        action: 'getCustomerNames'
                    }
                })
                .then( response => { 
                    if( response.data.message == 'Unauthorized' ) 
                        this.$router.push('/login');

                    this.loading = false;
                    this.customers = response.data;
                });
        },
        openDialog( item ) {
            if( item != null ) {
                this.selected = {
                    rotationNum: item.rotationNum,
                    customerId: item.customerNumber,
                    customerError: '',
                    fromDate: item.fromDate,
                    fromDateError: '',
                    toDate: item.toDate,
                    toDateError: '',
                };
            }

            this.newDialog = true;
        },
        closeDialog() {
            this.selected = {
                rotationNum: null,
                customerId: null,
                customerError: '',
                fromDate: null,
                fromDateError: '',
                toDate: null,
                toDateError: '',
            };
            this.newDialog = false;
        },
        formatDate( date ) {
            if( !date ) return null;

            const [year, month, day] = date.split( '-' );
            return `${month}/${day}/${year}`;
        },
        parseDate( date ) {
            if( !date ) return null;

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },
        isValid() {
            let errorFound = false;
            this.selected.customerError = this.selected.fromDateError = this.selected.toDateError = '';

            if( this.selected.customerId == undefined || this.selected.customerId == null ) {
                this.selected.customerError = 'requried';
                errorFound = true;
            }
            if( this.selected.fromDate == undefined || this.selected.fromDate == null || this.selected.fromDate.length == 0 ) {
                this.selected.fromDateError = 'requried';
                errorFound = true;
            }
            if( this.selected.toDate == undefined || this.selected.toDate == null || this.selected.toDate.length == 0 ) {
                this.selected.toDateError = 'requried';
                errorFound = true;
            }

            return !errorFound;
        },
        saveRotation() {
            if( !this.isValid() )
                return;

            let axiosOptions = {
                url: '/proc/data.php',
                method: 'post',
                data: {
                    rotationId: this.selected.rotationNum,
                    customerId: this.selected.customerId,
                    fromDate: this.selected.fromDate,
                    toDate: this.selected.toDate
                },
                params: {
                    action: 'saveRotation'
                },
                json: true,
            };

            this.$http( axiosOptions )
                .then( response => {
                    if( response.data.message == 'Unauthorized' ) 
                        this.$router.push('/login');

                    if( response.data.status == true ) {
                        this.closeDialog();
                        this.loading = true;
                        this.$http
                        .get( '/proc/data.php', {
                            params: {
                                action: 'getRotationDays'
                            }
                        })
                        .then( response => { 
                            this.loading = false;
                            this.rotationDays = response.data;
                        });
                    }
                });
        },
        openDeleteDialog( item ) {
            this.selected = {
                rotationNum: item.rotationNum,
                customerId: item.customerNumber,
                customerError: '',
                fromDate: item.fromDate,
                fromDateError: '',
                toDate: item.toDate,
                toDateError: '',
            };
            this.warningDialog = true;
        },
        closeDeleteDialog() {
            this.selected = {
                rotationNum: null,
                customerId: null,
                customerError: '',
                fromDate: null,
                fromDateError: '',
                toDate: null,
                toDateError: '',
            };
            this.warningDialog = false;
        },
        deleteRotation() {
            this.loading = true;
            this.$http
                .delete( '/proc/data.php', {
                    params: {
                        action: 'deleteRotation',
                        id: this.selected.rotationNum
                    }
                })
                .then( response => { 
                    this.loading = false;
                    if( response.data.message == 'Unauthorized' ) 
                        this.$router.push('/login');
                        
                    
                    if( response.data.status === true ) {
                        // remove invoice from list
                        let pos = this.rotationDays.map(function(e) { return e.rotationNum; }).indexOf( this.selected.rotationNum );
                        this.rotationDays.splice( pos, 1 );

                        this.selected = {
                            rotationNum: null,
                            customerId: null,
                            customerError: '',
                            fromDate: null,
                            fromDateError: '',
                            toDate: null,
                            toDateError: '',
                        };

                        this.warningDialog = false;
                        this.closeDialog();
                    }

                });
        }
    },
}
</script>

<style scoped>

</style>